import { useCallback, useEffect, useState } from 'react';
import { useThemeMediaQuery } from '@hooks/useThemeMediaQuery';

export const PLAY_SPEED = 500;
export const EASING = 'easeSinInOut';
export const INITIAL_HEIGHT = 508;

export const useBlogCarouselV2Controller = (numberOfSlides: number) => {
  const [slideIndex, setSlideIndex] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(3);

  const isMobile = useThemeMediaQuery('below_sm');
  const isTablet = useThemeMediaQuery('tablet');

  useEffect(() => {
    if (isMobile) {
      setSlidesToShow(1);
      if (isTablet) setSlidesToShow(2);
    } else {
      setSlidesToShow(3);
    }
  }, [isMobile, isTablet]);

  const handlePreviousOrNextSlide = useCallback(
    (typeOfButton: 'prev' | 'next') => {
      if (typeOfButton === 'prev') {
        if (slideIndex > 0) {
          setSlideIndex(slideIndex - slidesToShow);
        } else {
          if (numberOfSlides - slidesToShow < slidesToShow) {
            setSlideIndex(slidesToShow);
          } else {
            setSlideIndex(numberOfSlides - slidesToShow);
          }
        }
      } else {
        if (slideIndex < numberOfSlides - slidesToShow) {
          setSlideIndex(slideIndex + slidesToShow);
        } else {
          setSlideIndex(0);
        }
      }
    },
    [numberOfSlides, slideIndex, slidesToShow]
  );

  return {
    slideIndex,
    slidesToShow,
    setSlideIndex,
    handlePreviousOrNextSlide,
  };
};
